module.exports = __webpack_public_path__ + "static/img/11.ebd92e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/11/zh/11.png
// module id = ejj+
// module chunks = 0